module.exports = __webpack_public_path__ + "static/media/icn_briefcase.d659d65d.svg";